{
	"address-search": {
		"address-search": "Address search",
		"address-search-placeholder": "Search for a street",
		"info-text": "Please note that the numbers are based on data from Byggðastofnun and Pósturinn cannot guarantee the accuracy of the data.",
		"place": "Place",
		"road": "Road",
		"search": "Search"
	},
	"homes-and-companies": {
		"companies": "Companies",
		"homes": "Homes",
		"homes-and-companies": "Homes and companies",
		"place": "Place",
		"postcode": "Postcode"
	},
	"letter-postbox": {
		"address": "Address",
		"letter-postbox": "Mailbox",
		"letter-postboxes": "Mailboxes",
		"name": "Name",
		"zip": "Zip code"
	},
	"mapcover": "Map of postcodes cover",
	"mapcover-duratation": "Valid from 1st of October 2019",
	"mapcover-move": "View larger map",
	"noresult": "No results",
	"service-level": {
		"company-service": "Company service",
		"home-delivery-companies": "Home delivery for companies",
		"home-delivery-individual": "Home delivery for individuals",
		"last-safe-dropoff-time": "Last safe dropoff time",
		"opening-hours": "Opening hours",
		"partner": "Partner",
		"place": "Place",
		"postoffice": "Post office",
		"service": "Service",
		"service-level": "Service level",
		"service-level-table": "Service level table",
		"service-postoffice": "Service post office"
	}
}
